import React from "react"
// import { Link } from "gatsby"
import Layout from "../components/Layout"

export default () => (
    <Layout headerTitle="Contribute" headerSubtitle=""></Layout>
)
